/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { Component } from 'react';
import { connect } from 'react-redux';
// import Clock from 'react-live-clock';
// import Toast from './sub_components/toast';
import * as authServices from '../services/authService';
import * as accountServices from '../services/accountService'
import * as utilService from '../services/utilService'
import Joinnowpopup from './sub_components/joinnowpopup'
import Loginpopup from './sub_components/loginpopup'
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { staticContentsImagePath as BASE_IMAGE_PATH, OPERATOR_ID } from '../configs/const';
// import { ReCAPTCHA_KEY } from '../configs/const';
// import ReCAPTCHA from "react-google-recaptcha";
import * as constants from '../configs/const'
import { APK_FILE_NAME, SOCIALMEDIALINKS } from '../configs/apkFileName';
import LiveClock from './sub_components/liveClock';
import {BRANDLOGOFILENAME} from '../configs/authSignupConfig';
import {showAdminBannerLink, showBHMBannerLink} from '../configs/casinoShowList';
// import bannerList from 'https://images.staticcontents.com/banners/list.json'

 let oid = OPERATOR_ID.toLowerCase()
// const recaptchaRef = React.createRef();
const hostname = window && window.location && window.location.hostname;

class Loginb2cHeader extends Component {
    constructor(props) {
        super(props);
        this.state = {
            // uid: "",
            // passcode: "",
            // passVisible: false,
            // rememberMe: false,
            date: "",
            // showToast: false,
            toastMsg: "",
            toastType: "",
            showDownLoad: false,
            inMaitanence: false,
            hasUmShow: true,
            recapchaVal: "",
            isDev: false,
            desktopBanners: {},
            mobileBanners: {},
            operatorDesktopBanners: {},
            operatorMobileBanners: {},
            showPopup: false,
            showLoginPopup: false,
            selectedSection : "",
            clientWidth: document.documentElement.clientWidth,
        };
    }
    formatDate() {
        let date = new Date()
        let month = [];
        month[0] = "Jan";
        month[1] = "Feb";
        month[2] = "Mar";
        month[3] = "Apr";
        month[4] = "May";
        month[5] = "Jun";
        month[6] = "Jul";
        month[7] = "Aug";
        month[8] = "Sept";
        month[9] = "Oct";
        month[10] = "Nov";
        month[11] = "Dec";
        let mn = month[date.getMonth()];
        let yr = date.getUTCFullYear();
        let dt = date.getDate();
        dt = dt > 9 ? dt : "0" + dt
        let hr = date.getHours();
        hr = hr > 9 ? hr : "0" + hr
        let min = date.getMinutes();
        min = min > 9 ? min : "0" + min
        let formatedDate = dt + " " + mn + " " + yr + ", " + hr + ":" + min
        return formatedDate
    }

    formatPickerDate(date) {
        var d = date,
            month = '' + (d.getMonth() + 1),
            day = '' + d.getDate(),
            year = d.getFullYear();

        if (month.length < 2)
            month = '0' + month;
        if (day.length < 2)
            day = '0' + day;
        year = year.toString().slice(-2)
        return [year, month, day].join('');
    }

    async componentDidMount() {
        localStorage.removeItem("homeData")
        if (constants.isDev) {
            this.setState({ isDev: true })
        }
        let savedData = localStorage.getItem("rememberData")
        if (!!savedData) {
            savedData = JSON.parse(savedData)
            if (!!savedData && !!savedData.uid) {
                this.setState({ rememberMe: true, uid: savedData.uid, passcode: !!savedData.passcode ? savedData.passcode : "" })
            }
        }
        if (!window.location.href.includes("apk")) {
            this.setState({ showDownLoad: true })
            localStorage.setItem("appType", "web")
        } else {
            localStorage.setItem("appType", "mobile")
        }
        
        
        // headers.append('Referrer-Policy', 'origin');
        // options.referrerPolicy = 'no-referrer-when-downgrade'; Referrer-Policy "origin"
        // headers.append('Accept', '*/*');
        // headers.append('Access-Encoding', 'gzip, deflate, br');
        // headers.append('Connection', 'keep-alive');
        var options = {};
        var headers = new Headers();
        headers.append('Content-Type', 'application/json');
        // headers.append('Access-Control-Allow-Origin', '*');
        options.headers = headers;

        

        
        // let banners = await utilService.getBanner()
        // let banners = await utilService.getBannerListJson()
        // debugger
        // utilService.getBannerListJson().then((res)=>{
        //     if(!!res){
        //         let desktop_banners_arr = res.desktop
        //         let mobile_banners_arr = res.mobile

        //         let desktop_banners = {}
        //         for (var banner of desktop_banners_arr) {
        //             desktop_banners[banner.split(".")[0]] = `https://images.staticcontents.com/banners/desktop_banner_${banner}`
        //         }

        //         let mobile_banners = {}
        //         for (var mobbanner of mobile_banners_arr) {
        //             mobile_banners[mobbanner.split(".")[0]] = `https://images.staticcontents.com/banners/mobile_banner_${mobbanner}`
        //         }

        //         this.setState({ desktopBanners: desktop_banners, mobileBanners: mobile_banners })
        //     }
        // })
        if(showAdminBannerLink){
            utilService.getOperatorBannerListJson().then((res) => {
                if (!!res) {
                    let desktop_banners_arr = res.desktop
                    let mobile_banners_arr = res.mobile
    
                    let desktop_banners = {}
                    for (var banner of desktop_banners_arr) {
                        desktop_banners[banner.split(".")[0]] = `${BASE_IMAGE_PATH}/${OPERATOR_ID.toLowerCase()}/banners/desktop_banner_${banner}`
                    }
    
                    let mobile_banners = {}
                    for (var mobbanner of mobile_banners_arr) {
                        mobile_banners[mobbanner.split(".")[0]] = `${BASE_IMAGE_PATH}/${OPERATOR_ID.toLowerCase()}/banners/mobile_banner_${mobbanner}`
                    }
                    
                    this.setState({ operatorDesktopBanners: desktop_banners, operatorMobileBanners: mobile_banners },()=>{
                        if(showBHMBannerLink){
                            utilService.getBannerListJson().then((res) => {
                                if (!!res) {
                                    let desktop_banners_arr = res.desktop
                                    let mobile_banners_arr = res.mobile
                                    
                                    let desktop_banners = {}
                                    for (var banner of desktop_banners_arr) {
                                        desktop_banners[banner.split(".")[0]] = `${BASE_IMAGE_PATH}/banners/desktop_banner_${banner}`
                                    }
                                    let mobile_banners = {}
                                    for (var mobbanner of mobile_banners_arr) {
                                        mobile_banners[mobbanner.split(".")[0]] = `${BASE_IMAGE_PATH}/banners/mobile_banner_${mobbanner}`
                                    }
                    
                                    this.setState({ desktopBanners: desktop_banners, mobileBanners: mobile_banners })
                                }
                            })
                        }
                    })
                }
            })
        } else { 
            if(showBHMBannerLink){ 
                utilService.getBannerListJson().then((res) => {
                    if (!!res) {
                        let desktop_banners_arr = res.desktop
                        let mobile_banners_arr = res.mobile

                        let desktop_banners = {}
                        for (var banner of desktop_banners_arr) {
                            desktop_banners[banner.split(".")[0]] = `${BASE_IMAGE_PATH}/banners/desktop_banner_${banner}`
                        }

                        let mobile_banners = {}
                        for (var mobbanner of mobile_banners_arr) {
                            mobile_banners[mobbanner.split(".")[0]] = `${BASE_IMAGE_PATH}/banners/mobile_banner_${mobbanner}`
                        }

                        this.setState({ desktopBanners: desktop_banners, mobileBanners: mobile_banners })
                    }
                })
            }
        }
        // if (!!banners.items && banners.items.length > 0 && banners.isSuccess) {

        //     let desktop_banners_arr = banners.items.filter((banner) => { return banner.includes("desktop_banner") })
        //     let mobile_banners_arr = banners.items.filter((banner) => { return banner.includes("mobile_banner") })

        //     let desktop_banners = {}
        //     for (var banner of desktop_banners_arr) {
        //         desktop_banners[banner.split("_")[2].split(".")[0]] = banner
        //     }

        //     let mobile_banners = {}
        //     for (var mobbanner of mobile_banners_arr) {
        //         mobile_banners[mobbanner.split("_")[2].split(".")[0]] = mobbanner
        //     }

        //     this.setState({ desktopBanners: desktop_banners, mobileBanners: mobile_banners })
        // }
        if(document.documentElement.clientWidth <= 991)
        {
            this.respNavMenuListeners();
        }
    }

    respNavMenuListeners(){
        // sidebar open close js code
        let navLinks = document.querySelector(".cls-nav-links ");
        let menuOpenBtn = document.querySelector(".cls-bx-menu");
        let menuCloseBtn = document.querySelector(".cls-bx-x");
        menuOpenBtn.onclick = function() {
        navLinks.style.left = "0";
        }
        menuCloseBtn.onclick = function() {
        navLinks.style.left = "-100%";
        }


        // sidebar submenu open close js code
        // let htmlcssArrow = document.querySelector(".cls-htmlcss-arrow");
        // htmlcssArrow.onclick = function() {
        // navLinks.classList.toggle("show1");
        // }
        // let moreArrow = document.querySelector(".cls-more-arrow");
        // moreArrow.onclick = function() {
        // navLinks.classList.toggle("show2");
        // }
        // let jsArrow = document.querySelector(".cls-js-arrow");
        // jsArrow.onclick = function() {
        // navLinks.classList.toggle("show3");
        // }
    }

    // showToast(msg, type) {
    //     let self = this
    //     this.setState({ toastMsg: msg, toastType: type, showToast: true }, () => {
    //         setTimeout(() => {
    //             self.setState({ toastMsg: "", toastType: "", showToast: false })
    //         }, 3000);
    //     })
    // }

    onChange(e) {
        const name = e.target.name;
        const value = e.target.value;
        this.setState({ [name]: value })
    }

    handleKey(e) {
        if (e.keyCode === 13) {
            this.signIn();
        }
    }

    signIn() {
        let body = {
            "username": this.state.uid.trim().toLowerCase(),
            "password": this.state.passcode
        }
        if (!this.state.uid.trim()) {
            this.props.notify("Please Insert Username!", "error")
            return false
        }
        if (!this.state.passcode) {
            this.props.notify("Please Insert Password!", "error")
            return false
        }
        if (this.state.rememberMe) {
            let data = {
                "uid": this.state.uid.trim().toLowerCase(),
                "passcode": this.state.passcode
            }
            localStorage.setItem("rememberData", JSON.stringify(data))
        } else {
            localStorage.removeItem("rememberData")
        }
        authServices.signin(body).then(async (result) => {
            if (result.token) {
                let data = {
                    token: result.token
                }
                let accessControl = {
                    sports: true,
                    binary: true,
                    casino: true
                }
                localStorage.setItem("userAuthDetail", JSON.stringify(data))
                let velidateData = await authServices.velidateToken()

                if (!!velidateData.role && velidateData.role === "Client") {
                    localStorage.setItem("tokenData", JSON.stringify(velidateData))
                    localStorage.setItem("accessControl", JSON.stringify(accessControl))
                    let accData = await accountServices.getAccountData()
                    if(!!accData && !!accData.userLock && accData.userLock){
                        this.props.notify("User Is Locked. Please Contact Upperline!", "error")
                        this.logout()
                    }
                    localStorage.setItem("accountData", JSON.stringify(accData))
                    let configData = await authServices.getConfigButton()
                    localStorage.setItem("buttonsValues", JSON.stringify(configData))
                    if (velidateData.pwdch) {
                        this.props.history.push("/setpassword");
                    }
                    else {
                        // this.props.history.push("/home");
                        window.location.href = "/home"
                    }
                } else if (!!velidateData.role && velidateData.role !== "Client") {
                    this.props.notify(velidateData.role + " user is not allow to access this portal.", "error")
                } else {
                    this.props.notify(velidateData.exception.message, "error")
                }
            } else {
                this.props.notify(result.exception.message, "error")
            }
        })
    }

    logout() {
        let appType = localStorage.getItem("appType")
        let rememberData = localStorage.getItem("rememberData")
        localStorage.clear()
        localStorage.setItem("rememberData", rememberData)
        if (appType === "mobile") {
            window.location.href = window.location.origin + "/apk";
        } else {
            window.location.href = window.location.origin + "/auth";
        }
    }

    // onPasswodVisible() {
    //     if (!!this.state.passVisible) {
    //         document.getElementById("passcode").type = "Password"
    //         document.getElementById("passcode-m").type = "Password"
    //     } else {
    //         document.getElementById("passcode").type = "text"
    //         document.getElementById("passcode-m").type = "text"
    //     }
    //     this.setState({ passVisible: !this.state.passVisible })
    // }

    hidePopup(view = "") {
        this.setState({ hasUmShow: false, [`show${view}Popup`]:false })
        
    }
    showPopup(view = "") {
        // debugger
        this.setState({ [`show${view}Popup`]: true })
    }
    // hideLoginPopup() {
    //     this.setState({ hasUmShow: false, showloginPopup:false })
        
    // }
    // showLoginPopup() {
    //     this.setState({ showloginPopup: true })
    // }
    togglePopupBetweenLoginSignup(view = ""){
        this.hidePopup(view === "" ? "Login" : "");
        this.showPopup(view);
    }
    toggleSelectedSection(name){
        if(window.location.pathname !== '/auth' && !window.location.pathname.includes('/auth/') && window.location.pathname !== '/'){
            this.props.history.push(`/auth/${name}`)
        } else {
            this.props.toggleSelectedSection(name);
        }
    }
    render() {
        let settings = {
            dots: true,
            infinite: true,
            speed: 300,
            slidesToShow: 1,
            slidesToScroll: 1,
            autoplay: true,
            autoplaySpeed: 5000
        };
        let SclMd = localStorage.getItem("SocialMedia");
        if(!!SclMd && Object.keys(SclMd).length > 0){
            SclMd = JSON.parse(SclMd);
        }
        return (
        <>
       
        <div className='header-fix'>
            <div className='header-top flex-center-space'>
                <div className='left flex-center float-left'>
                    <ul className='socialmediaicon'>
                        <li><a href={SclMd?.SOCIALMEDIALINKS?.instagram} target='_blank' alt="Instagram" rel="noreferrer" data-toggle="tooltip" data-placement="bottom" title="Instagram"><i className="fa fa-instagram mr-1"></i><span className='m-hide'>Instagram</span></a></li>
                        <li><a href={SclMd?.SOCIALMEDIALINKS?.facebook} target='_blank' alt="Facebook" rel="noreferrer" data-toggle="tooltip" data-placement="bottom" title="Facebook"><i className="fa fa-facebook mr-1"></i><span className='m-hide'>Facebook</span></a></li>
                        <li><a href={SclMd?.SOCIALMEDIALINKS?.twitter} target='_blank' alt="Twitter" rel="noreferrer" data-toggle="tooltip" data-placement="bottom" title="Twitter"><i className="fa fa-twitter mr-1"></i><span className='m-hide'>Twitter</span></a></li>
                        <li><a href={SclMd?.SOCIALMEDIALINKS?.telegram} target='_blank' alt="Telegram Channel" rel="noreferrer" data-toggle="tooltip" data-placement="bottom" title="Telegram" ><i className="fa fa-telegram mr-1"></i><span className='m-hide'>Telegram</span></a></li>
                        <li><a href='#'  alt="Make a call" rel="noreferrer" data-toggle="tooltip" data-placement="bottom" title="Make a call"><i className="fa fa-phone mr-1"></i><span className='m-hide'>Make a call</span></a></li>
                        <li onClick={() => { this.props.history.push("/faq") }}>
                            <a href='#' alt="Make a call" rel="noreferrer" data-toggle="tooltip" data-placement="bottom" title="Have Question?" className={window.location.pathname === "/faq" ? "active" : ""}><i className="fa fa-question-circle-o mr-1"></i><span className='m-hide'>Have Question?</span></a>
                        </li>
                        <li><a href='#' alt="Android" rel="noreferrer" data-toggle="tooltip" data-placement="bottom" title="Application" onClick={() => { window.location.href = `https://apk.staticcontent.io/${APK_FILE_NAME}.apk` }}><i className="fa fa-mobile mr-1"></i><span className='m-hide'>Application</span></a></li>
                    </ul>
                </div>
                <div className='left flex-center float-right'>
                <div className='header-time'>
                    <LiveClock></LiveClock>
                </div>
                {/* <div className='header-time'>{ this.formatDate() }</div>   */}
                {/* <div className='header-time'>
                    {/* date={'1997-12-31T14:15:23+01:00'} *}
                    <Clock ticking={true} format={'DD MMM YYYY, HH:mm:ss'} />
                </div> */}
                </div>
                
            </div>
            <header className='loginheader'>
                <div className="container-fluid">
                   <div className="row">
                        <div className="col-6 col-sm-6 col-md-5 col-lg-4 col-xl-3 logob2c">
                            <div className="logo">
                                {/* <i className="fa fa-bars icon-toggle-right cls-bx-menu" onClick={() => { this.openNav() }}></i> */}
                                <i className="fa fa-bars icon-toggle-right cls-bx-menu"></i>
                                <a href="" className='b2clogolink'><img src={`${BASE_IMAGE_PATH}/${oid}/uimg/${BRANDLOGOFILENAME}`} width="195" height="60px" alt="logo" className='loginlogo' /></a>
                            </div>
                        </div>
                        <div className="col-6 col-sm-6 col-md-7 col-lg-8 col-xl-9 login-signup-header">
                            <div className="">
                                <ul className="login-wrap ">                                    
                                    <li>
                                        <a id='btnLoginb2cLogin' type="submit" className=" b2clogin" tabIndex={3} onClick={(e) => { this.showPopup("Login") }}><i className="fa fa-user mr1" aria-hidden="true"></i> Log in </a>
                                    </li>
                                    <li>
                                        <a type="submit" className="b2csignup" tabIndex={3} onClick={() => { this.showPopup() }} style={{ cursor: "pointer" }}>SIGN up </a>
                                    </li>
                                </ul>
                            </div>
                            <div className="maintenance d-none">
                                {/* <div className="maintenance-title">Our site is under maintenance</div>
                                <div className="maintenance-text">
                                    Our website is currenty undergoing scheduled maintenance.<br />
                                    We should be back shortly. Thank you for your patience.</div> */}
                            </div>
                        </div>
                    </div>
                </div>
            </header>
            <section className='b2cmenu'>
                <nav>
                    <div className="navbar cls-navbar">
                        <i className='bx bx-menu cls-bx-menu'></i>
                    {/* <div className="logo"><a href="#">CodingLab</a></div> */}
                    <div className="nav-links cls-nav-links">
                        <div className="sidebar-logo">
                            {/* <span className="logo-name">Main Menu</span> */}
                        <i className='bx bx-x cls-bx-x fa fa-times-circle' ></i>
                        </div>
                        <ul className="links " >
                            <li>
                                <a href="/auth"  className={window.location.pathname === "/auth" || window.location.pathname === "/"? "active" : ""}>Live Casino</a></li>
                            <li onClick={() => { this.props.history.push("/exchange") }}>
                                <a href="" className={window.location.pathname === "/exchange" ? "active" : ""}>EXCHANGE</a>
                            {/* <i className='bx bxs-chevron-down htmlcss-arrow cls-htmlcss-arrow arrow fa fa-angle-down  '></i>
                            <ul className="htmlCss-sub-menu sub-menu">
                            <li><a href="#">Web Design</a></li>
                            <li><a href="#">Login Forms</a></li>
                            <li><a href="#">Card Design</a></li>
                            <li className="more">
                                <span><a href="#">More</a>
                                    <i className='bx bxs-chevron-right arrow more-arrow cls-more-arrow fa fa-angle-down'></i>
                                </span>
                                <ul className="more-sub-menu sub-menu">
                                    <li><a href="#">Neumorphism</a></li>
                                    <li><a href="#">Pre-loader</a></li>
                                    <li><a href="#">Glassmorphism</a></li>
                                </ul>
                            </li>
                            </ul> */}
                            </li>
                            {/* <li onClick={() => { this.props.history.push("/loginb2cCasino") }}>
                                <a href="" className={window.location.pathname === "/loginb2cCasino" ? "active" : ""}>Live Casino</a>
                            </li> */}
                            {/* <li onClick={() => { this.props.history.push("/lesport") }}>
                                <a href="" className={window.location.pathname === "/lesport" ? "active" : ""}>E-Sports</a></li> */}
                            <li onClick={() => { this.props.history.push("/lvsport") }}>
                                <a href="" className={window.location.pathname === "/lvsport" ? "active" : ""}>V-Sports</a></li>                        
                            <li onClick={() => { this.props.history.push("/offers") }}>
                                <a href="" className={window.location.pathname === "/offers" ? "active" : ""}>Offers</a></li>                        
                        </ul>
                        <button className='mobileapp' onClick={() => { window.location.href = `https://apk.staticcontent.io/${APK_FILE_NAME}.apk` }}><i className='fa fa-mobile mr-2'></i>Mobile App</button>

                        <div className='header-mobile__content'>
                            <ul className='mobilemenu_ul'>
                                <li><a href='#innersection' className={this.props.selectedSection === "" ? 'active' : ''} onClick={() => this.toggleSelectedSection('')}>Home</a></li>
                                <li><a href='#innersection' className={this.props.selectedSection === "aboutus" ? 'active' : ''} onClick={() => this.toggleSelectedSection('aboutus')}>About Us</a></li>
                                <li><a href='#innersection' className={this.props.selectedSection === "termandconditions" ? 'active' : ''} onClick={() => this.toggleSelectedSection('termandconditions')}>Terms and Conditions</a></li>
                                <li><a href='#innersection' className={this.props.selectedSection === "privacypolicy" ? 'active' : ''} onClick={() => this.toggleSelectedSection('privacypolicy')}>Privacy Policy</a></li>
                                <li><a href='#innersection' className={this.props.selectedSection === "bettingrules" ? 'active' : ''} onClick={() => this.toggleSelectedSection('bettingrules')}>Betting Rules</a></li>
                                <li><a href='#innersection' className={this.props.selectedSection === "depositsandwithdrawals" ? 'active' : ''} onClick={() => this.toggleSelectedSection('depositsandwithdrawals')}>Deposits and Withdrawals Rules</a></li>
                            </ul>
                        </div>
                        <div className='header_mobile_socialicon'>
                            <ul className='mobilemenuicon_ul'>
                                <li><a href='https://www.instagram.com/rdreamfair_official/' target='_blank' alt="Instagram" rel="noreferrer" data-toggle="tooltip" data-placement="bottom" title="Instagram"><i className="fa fa-instagram mr-1"></i></a></li>
                                <li><a href='https://www.facebook.com/rdreamfair' target='_blank' alt="Facebook" rel="noreferrer" data-toggle="tooltip" data-placement="bottom" title="Facebook"><i className="fa fa-facebook mr-1"></i></a></li>
                                <li><a href='https://twitter.com/rDreamFair' target='_blank' alt="Twitter" rel="noreferrer" data-toggle="tooltip" data-placement="bottom" title="Twitter"><i className="fa fa-twitter mr-1"></i></a></li>
                                <li><a href='https://t.me/rDreamFair_official' target='_blank' alt="Telegram Channel" rel="noreferrer" data-toggle="tooltip" data-placement="bottom" title="Telegram" ><i className="fa fa-telegram mr-1"></i></a></li>
                                <li><a href='#'  alt="Make a call" rel="noreferrer" data-toggle="tooltip" data-placement="bottom" title="Make a call"><i className="fa fa-phone mr-1"></i></a></li>
                               
                            </ul>
                        </div>

                    </div>
                    

                    {/* <div className="search-box">                       
                        <p>June 6, 2022, 03:15:46PM</p>                        
                    </div> */}
                    </div>
                </nav>
            </section>
        </div>
            {/* {!!this.state.showToast && <Toast notification={this.state.toastMsg} type={this.state.toastType} />} */}
            {this.state.showPopup && <Joinnowpopup hidePopup={() => { this.hidePopup() }} showSweetAlert={(options) =>this.props.showSweetAlert(options)}  notify={this.props.notify} togglePopupBetweenLoginSignup={(view) => this.togglePopupBetweenLoginSignup(view)} toggleSelectedSection={(name)=>{ this.toggleSelectedSection(name) }} affCode={this.props.affCode}/>}
            {this.state.showLoginPopup && <Loginpopup hidePopup={() => { this.hidePopup("Login") }} showSweetAlert={(options) =>this.props.showSweetAlert(options)} history={this.props.history} notify={this.props.notify} togglePopupBetweenLoginSignup={(view) => this.togglePopupBetweenLoginSignup(view)}/>}
        </>
        )
    }
}

function mapStateToProps(state) {
    return {
    };
}

function mapDispatchToProps(dispatch) {
    return {
    };
}
export default connect(mapStateToProps, mapDispatchToProps)(Loginb2cHeader);